
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserService } from './services/user-service';

export const authGuard = (activatedRouteSnapshot: ActivatedRouteSnapshot) => {
    const data = activatedRouteSnapshot.data;
    const userService = inject(UserService);
    const router = inject(Router);

    return userService.getLoggedUser().pipe(
        map((response: any) => {
            if (data && data['roles']?.includes(response?.role)) {
                return true;
            }
            router.navigateByUrl('/');
            return false;
        })
    );
}